<div class="image-wrapper">
    <img *ngIf="!isDefault" (click)="fileInput.click()" [src]="_src" accept="image/*" />
    <div *ngIf="isDefault" class="default-placeholder" (click)="fileInput.click()">
        <mat-icon>add_photo_alternate</mat-icon>
    </div>
    <button *ngIf="excludable" type="button" (click)="deleteImage($event)" color="primary" class="mat-accent mat-icon-button-excludable">
        <mat-icon>delete</mat-icon>
    </button>
    <!-- <button *ngIf="editable" (click)="fileInput.click()" color="primary" class="mat-accent mat-icon-button-editable">
        <mat-icon>edit</mat-icon>
    </button> -->
</div>
<div #fileInput (click)="fileChange($event)" hidden></div>
<!-- <input type="file" name="image" [accept]="accept"> -->
